import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './hooks/useAuth'
import { MaintenanceCacheProvider } from './hooks/useMaintenanceCacheBus'
import RequireAuth from './components/RequireAuth'
import Login from './pages/Login'
import MaintenanceList from './pages/MaintenanceList'
import MaintenanceForm from './pages/MaintenanceForm'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'

function App() {
  return (
    <AuthProvider>
      <MaintenanceCacheProvider>
        <div className="min-h-screen bg-brand-surface-50 text-brand-text-primary">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/manutencao"
              element={<RequireAuth><MaintenanceList /></RequireAuth>}
            />
            <Route
              path="/manutencao/novo"
              element={<RequireAuth><MaintenanceForm /></RequireAuth>}
            />
            <Route
              path="/manutencao/editar/:id"
              element={<RequireAuth><MaintenanceForm /></RequireAuth>}
            />
          </Routes>
          <Toaster position="top-right" />
        </div>
      </MaintenanceCacheProvider>
    </AuthProvider>
  )
}

export default App